module.exports = __webpack_public_path__ + "img/oneRed.4829ca72.jpg";